import LocalizedStrings from 'react-localization';

import { en } from './en';

export const gammaI18n = new LocalizedStrings({ en });

export type GammaI18nType = typeof gammaI18n;
export type GammaI18nKey = keyof GammaI18nType;
